/**
 * apiOrigin.js — iter308u
 *
 * Returns the runtime origin to use for API calls. In the browser the
 * frontend should call the SAME origin it was loaded from so:
 *   1. Requests are same-origin → no CORS preflight needed.
 *   2. The outer Cloudflare Worker (iter308t) sees the request and
 *      sets X-Original-Host with the correct tenant hostname before
 *      forwarding to Emergent.
 *
 * The build-time `REACT_APP_BACKEND_URL` is only used as a fallback
 * for non-browser contexts (server-side rendering, build-time tests).
 *
 * Why this exists
 * ---------------
 * Originally the frontend pinned the API base to `REACT_APP_BACKEND_URL`
 * (e.g. `https://my.vyomos.io`). With Cloudflare for SaaS in front,
 * tenant subdomains like `demo.vyomos.io` would load the React app
 * locally but EVERY API call still went to `my.vyomos.io`, which:
 *   - Bypassed the tenant-host Cloudflare Worker
 *   - Triggered cross-origin CORS errors
 *   - Resolved to the platform tenant on the backend (wrong branding)
 */
export const apiOrigin = () => {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return (typeof window !== "undefined" && window.location ? window.location.origin : process.env.REACT_APP_BACKEND_URL) || "";
};
